import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ChannelTemplateCategory } from "../../../../domain/channel-template-category";
import { Subject } from "rxjs";
import { ActivatedRoute, Params, Router } from "@angular/router";

@Component({
  selector: "side-menu",
  templateUrl: "./side-menu.component.html",
  styleUrls: ["./side-menu.component.scss"],
})
export class ChooseTemplateSideMenuComponent {
  @Input()
  templateCategories: Array<ChannelTemplateCategory> = [];

  @Input()
  currentCategory: ChannelTemplateCategory;

  @Output()
  categoryClicked: EventEmitter<ChannelTemplateCategory> =
    new EventEmitter<ChannelTemplateCategory>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  categoryClickedHandler(category: ChannelTemplateCategory) {
    this.categoryClicked.emit(category);
  }

  searchTemplateClicked(searchExpression: string) {
    this.router.navigate(
      ["/tenant/choose-template?searchTitle=" + searchExpression.trim()],
      {
        queryParamsHandling: "merge",
      },
    );
  }
}
